import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EvaluacionService } from 'src/app/service/evaluacion/evaluacion.service';

@Component({
  selector: 'app-resumen-final',
  templateUrl: './resumen-final.component.html',
  styleUrls: ['./resumen-final.component.scss']
})

export class ResumenFinalComponent implements OnInit {
  titulo: string = "Evalúa tu factura";
  generandoPdf: boolean;
  arrSimuladorFinal: any = [];
  loading: boolean;
  isValid: any;
  isLoading: boolean;

  constructor(private router: Router, private evaluacionService: EvaluacionService) {
  }

  ngOnInit() {
    // AQUI VALIDO SI ESTOY INGRESANDO DESDE EL FORM DE respuesta O DIRECTAMENTE
    this.isValid = localStorage.getItem("isValid");
    if (this.isValid != 1) {
      this.router.navigate(['evalua-tu-factura']);
    } else {
      this.cargarResumen();
    }
  }

  cargarResumen() {
    this.isLoading = true;
    this.evaluacionService.subscriber$.subscribe(
      res => {
        this.isLoading = false;
        this.arrSimuladorFinal = res;
      },
      err => {
        this.isLoading = false;
        console.log("error: ", err);
      }
    );
    this.isValid = 0;
    localStorage.setItem("isValid", this.isValid);
  }

  volver() {
    this.isValid = 0;
    localStorage.setItem("isValid", this.isValid);
    this.router.navigate(['evalua-tu-factura']);
  }

  generarPDFProforma() {
    this.generandoPdf = true;
    window.open(this.arrSimuladorFinal.Url_Simulador, "_blank");
    window.open(this.arrSimuladorFinal.UrlResumen_Simulador, "_blank");
  }
}
